import { defineStore } from 'pinia'
import { Record } from '@/api/Models/CommunityBoardCombination'

export const useVideoStore = defineStore({
  id: 'video',
  state: () => ({
    swipeable: true, // 是否允许tab滑动切换
    tabDisabled: false, // 是否禁止tab点击切换
    enabled: true, // 是否允许swiper
    firstVideoData: {} as Record, // 短视频列表点击的视频数据，用于短视频详情第一个展示
    editVideoData: {} as Record // 短视频详情点击编辑的数据
  }),
  actions: {
    setSwipeable(swipeable: boolean) {
      this.swipeable = swipeable
    },
    setTabDisabled(tabDisabled: boolean) {
      this.tabDisabled = tabDisabled
    },
    setEnabled(enabled: boolean) {
      this.enabled = enabled
    },
    setFirstVideoData(data: Record) {
      this.firstVideoData = data
    },
    setEditVideoData(data: Record) {
      this.editVideoData = data
    }
  },
  getters: {
    getSwipeable(): boolean {
      return this.swipeable
    },
    getTabDisabled(): boolean {
      return this.tabDisabled
    },
    getEnabled(): boolean {
      return this.enabled
    },
    getFirstVideoData(): Record {
      return this.firstVideoData
    },
    getEditVideoData(): Record {
      return this.editVideoData
    }
  }
})
